<template>
    <div>
      
    <section id="team" class="ch-gw-team" style="padding-top: 3rem;min-height: 28rem;padding-bottom: 2rem;">
      <div class="container m_container ch-gw-animation">
        <div class="row" style="justify-content: space-between;">
            <div class="col-lg-4 col-md-6 m_ch-gw-blog"  v-for="(item,index) in patentList">
            <div class="ch-gw-blog">
              <div style="width: 100%;display:flex;flex-wrap: nowrap;justify-content: center;align-items: center;" >
                  <el-image 
                    style="width: 90%;"
                    :src="item" 
                    :preview-src-list="patentList">
                  </el-image>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 m_ch-gw-blog"  v-for="(item,index) in patentList.length%3">
            <div class="ch-gw-blog">
              <div style="width: 100%;display:flex;flex-wrap: nowrap;justify-content: center;align-items: center;" >
                 
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>
    <div style="width: 100%;display: flex;justify-content: center;padding-bottom: 2rem;">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="pageCount"
            @current-change="pagesChange">
        </el-pagination>
    </div>
   
    </div>
</template>
<script>
import {queryPatent } from "@/utils/gw";
export default {
  components:{

  },
  name: 'patent',
  data () {
    return {
      msg: '首页',
      pageIndex:1,
      pageCount:0,
      pageSize:0,
      patentList:[]
    }
  },
  mounted() {
    this.queryPatent()
  },
  methods:{
    pagesChange(v){
        console.log(v)
        this.pageIndex = v
        this.queryPatent()
    },
    queryPatent(){
      this.patentList = []
      var u = "?pageIndex="+this.pageIndex
      queryPatent(u).then((e)=>{
          console.log(" ----- ",e.data)
          this.pageCount = e.data.pageCount
          this.pageSize = e.data.pageSize
          e.data.patent.forEach((e)=>{
            this.patentList.push(e.imgUrl)
          })
          //this.patentList = e.data.patent
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/about/patent.vue